// ── TRANSLATIONS ─────────────────────────────────────────────────────────────
const T = {
  de: {
    ann:"Jede Uhr geprüft & zertifiziert — Ihr vertrauensvoller Marktplatz für Pre-Owned Uhren",
    n_shop:"Shop", n_sell:"Uhr verkaufen", n_src:"Uhr beschaffen",
    cart_lbl:"Warenkorb",
    h_label:"Kuratierte Pre-Owned Uhren",
    h_title:"Jede Uhr\nhat eine\nGeschichte.",
    h_sub:"Pre-loved Uhren für jeden Anlass. Sorgfältig ausgewählt. Bereit für das nächste Kapitel.",
    h_cta1:"Kollektion entdecken", h_cta2:"Uhr verkaufen",
    col_title:"Aktuelle Angebote", col_all:"Alle anzeigen",
    feat_label:"Pre-Owned Service",
    feat_title:"Verkaufen Sie mit Vertrauen.",
    feat_p:"Unser Netzwerk aus Sammlern, Händlern und Liebhabern ermöglicht es Ihnen, Ihre Uhr schnell, sicher und zum bestmöglichen Preis zu verkaufen.",
    feat_cta:"Jetzt verkaufen",
    t1h:"Geprüfte Echtheit", t1p:"Jede Uhr durchläuft eine mehrstufige Echtheitsprüfung durch zertifizierte Uhrmacher vor dem Verkauf.",
    t2h:"Servicehistorie", t2p:"Vollständige Dokumentation über Revisionen, Reparaturen und Zustand — transparente Kaufentscheidung.",
    t3h:"Europaweiter Versand", t3p:"Versicherter, rückverfolgbarer Versand in über 40 Länder. 14 Tage Rückgaberecht.",
    nl_h:"Neue Angebote als Erster erfahren",
    nl_p:"Tragen Sie sich ein und erhalten Sie exklusive Einblicke in neue Ankünfte, Rabatte und limitierte Angebote.",
    nl_ph:"Ihre E-Mail-Adresse", nl_btn:"Anmelden",
    f_about:"Polardials — Kuratierter Marktplatz für geprüfte Pre-Owned Uhren & Schmuck.",
    f_shop:"Shop", f_all:"Alle Uhren", f_new:"Neu eingetroffen",
    f_svc:"Service", f_ship:"Versand & Rücksendung", f_auth:"Authentizität",
    f_guar:"Garantie", f_co:"Unternehmen", f_abt:"Über uns",
    f_sus:"Nachhaltigkeit", f_press:"Presse", f_cont:"Kontakt",
    f_copy:"© 2026 Polardials — Alle Rechte vorbehalten",
    cart_title:"Warenkorb", cart_tot:"Gesamt", cart_ck:"Zur Kasse",
    cart_empty:"Ihr Warenkorb ist leer.",
    m_add:"In den Warenkorb", m_close:"Sofort kaufen",
    svc_label:"Unsere Services",
    sell_h:"Möchten Sie Ihre Uhr verkaufen?",
    sell_p1:"Senden Sie uns Fotos mit Details, wir bewerten Ihr Stück und finden den richtigen Käufer zum bestmöglichen Marktpreis.",
    sell_p2:"Von der Bewertung bis zur sicheren Übergabe übernehmen wir alles.",
    ss1h:"Fotos & Details einsenden", ss1p:"Laden Sie Fotos hoch und beschreiben Sie Modell, Zustand und Zubehör.",
    ss2h:"Kostenlose Bewertung erhalten", ss2p:"Unser Expertenteam meldet sich innerhalb von 24 Stunden.",
    ss3h:"Verkaufen & Erlös erhalten", ss3p:"Nach Bestätigung übernehmen wir den Verkauf.",
    sf_title:"Ihr Stück einreichen",
    src_h:"Ihr persönlicher\nSourcing-Service.",
    src_p1:"Teilen Sie uns mit, was Sie suchen — wir beschaffen außergewöhnliche Pre-owned-Uhren über unser weltweites Netzwerk.",
    src_p2:"Provision erst nach Lieferung und Ihrer Bestätigung.",
    sr1h:"Wunsch & Budget mitteilen", sr1p:"Marke, Modell, Referenz, Budget und Zustand angeben.",
    sr2h:"Wir suchen für Sie", sr2p:"Händler, Sammler und Auktionshäuser werden aktiviert.",
    sr3h:"Erst nach Bestätigung zahlen", sr3p:"Provision fällt nur an, wenn Sie vollständig zufrieden sind.",
    srcf_title:"Sourcing-Anfrage stellen",
    f_fn:"Vorname", f_ln:"Nachname", f_em:"E-Mail", f_ph:"Telefon (optional)",
    f_bm:"Marke & Modell", f_rf:"Referenznummer", f_yr:"Baujahr (ca.)",
    f_cd:"Zustand", f_ac:"Vorhandenes Zubehör", f_pr:"Ihre Preisvorstellung (€)",
    f_no:"Anmerkungen", f_priv:"Mit dem Absenden stimmen Sie zu, dass wir Ihre Daten zur Bearbeitung Ihrer Anfrage verwenden.",
    f_sub:"Anfrage absenden", f_sel:"Bitte wählen …",
    cd1:"Neuwertig / ungetragen", cd2:"Sehr gut — kaum Gebrauchsspuren",
    cd3:"Gut — normale Gebrauchsspuren", cd4:"Akzeptabel — sichtbare Abnutzung",
    ac1:"Uhr + Box + Papiere (Full Set)", ac2:"Uhr + Box", ac3:"Uhr + Papiere", ac4:"Nur die Uhr",
    f_wm:"Gesuchte Marke & Modell", f_rf2:"Referenznummer (falls bekannt)",
    f_cat:"Kategorie", f_bmin:"Mindestbudget (€)", f_bmax:"Maximalbudget (€)",
    f_tf:"Zeitrahmen", f_det:"Weitere Details & Wünsche",
    f_priv2:"Wir kontaktieren Sie ausschließlich im Zusammenhang mit Ihrer Suchanfrage.",
    cat1:"Sportuhr", cat2:"Dressuhr / Klassisch", cat3:"Komplikation", cat4:"Vintage", cat5:"Schmuck",
    tf1:"So schnell wie möglich", tf2:"Innerhalb 1 Monat", tf3:"Innerhalb 3 Monate", tf4:"Kein Zeitdruck",
    s_ok_h:"Vielen Dank!", s_ok_p:"Wir melden uns innerhalb von 24 Stunden.",
    src_ok_h:"Anfrage erhalten!", src_ok_p:"Wir beginnen sofort und melden uns in 48 Stunden.",
    badge_new:"Neu", spec_cond:"Zustand", spec_acc:"Zubehör",
    cond_ex:"Ausgezeichnet", cond_vg:"Sehr gut", cond_gd:"Gut",
    t_cart_a:"zum Warenkorb hinzugefügt", t_sub:"Angemeldet — danke!",
  },
  en: {
    ann:"Authenticity guaranteed — Free shipping",
    n_shop:"Shop", n_sell:"Sell Yours", n_src:"Sourcing",
    cart_lbl:"Cart",
    h_label:"Curated Pre-Owned Watches",
    h_title:"Every watch\ntells a\nstory.",
    h_sub:"Pre-loved watches for every occasion. Carefully selected. Ready for the next chapter.",
    h_cta1:"Discover Collection", h_cta2:"Sell Your Watch",
    col_title:"Current Offerings", col_all:"View all",
    feat_label:"Pre-Owned Service",
    feat_title:"Sell with confidence.",
    feat_p:"Our network of collectors, dealers and enthusiasts allows you to sell your watch quickly, securely and at the best possible price.",
    feat_cta:"Sell Now",
    t1h:"Verified Authenticity", t1p:"Every watch undergoes a multi-stage authenticity check by certified watchmakers before listing.",
    t2h:"Full Service History", t2p:"Complete documentation on revisions, repairs and condition — transparent buying decisions.",
    t3h:"Europewide Shipping", t3p:"Insured, trackable shipping to over 40 countries. 14-day return policy.",
    nl_h:"Be First to Know",
    nl_p:"Subscribe and receive exclusive insights into new arrivals, rarities and limited offers.",
    nl_ph:"Your email address", nl_btn:"Subscribe",
    f_about:"Polardials — Curated marketplace for authenticated pre-owned watches & jewelry.",
    f_shop:"Shop", f_all:"All Watches", f_new:"New Arrivals",
    f_svc:"Service", f_ship:"Shipping & Returns", f_auth:"Authentication",
    f_guar:"Warranty", f_co:"Company", f_abt:"About Us",
    f_sus:"Sustainability", f_press:"Press", f_cont:"Contact",
    f_copy:"© 2026 Polardials — All rights reserved",
    cart_title:"Shopping Cart", cart_tot:"Total", cart_ck:"Checkout",
    cart_empty:"Your cart is empty.",
    m_add:"Add to Cart", m_close:"Buy Now",
    svc_label:"Our Services",
    sell_h:"Looking to sell your watch?",
    sell_p1:"Send us photos with details, we'll evaluate your piece and find the right buyer at the best market price.",
    sell_p2:"From valuation to secure handover, we handle everything.",
    ss1h:"Submit Photos & Details", ss1p:"Upload photos and describe model, condition and accessories.",
    ss2h:"Receive Free Valuation", ss2p:"Our expert team will contact you within 24 hours.",
    ss3h:"Sell & Receive Payment", ss3p:"Once confirmed, we handle the sale.",
    sf_title:"Submit Your Piece",
    src_h:"Your personal\nsourcing service.",
    src_p1:"Tell us what you're looking for — we source exceptional pre-owned watches through our worldwide network.",
    src_p2:"Commission only after delivery and your confirmation.",
    sr1h:"Share Your Wish & Budget", sr1p:"Specify brand, model, reference, budget and desired condition.",
    sr2h:"We Search For You", sr2p:"Dealers, collectors and auction houses are activated.",
    sr3h:"Pay Only After Confirmation", sr3p:"Commission only applies once you are fully satisfied.",
    srcf_title:"Sourcing Request",
    f_fn:"First Name", f_ln:"Last Name", f_em:"Email", f_ph:"Phone (optional)",
    f_bm:"Brand & Model", f_rf:"Reference Number", f_yr:"Year (approx.)",
    f_cd:"Condition", f_ac:"Available Accessories", f_pr:"Your Price Expectation (€)",
    f_no:"Notes", f_priv:"By submitting you agree that we use your data to process your request.",
    f_sub:"Send Request", f_sel:"Please select …",
    cd1:"Mint / Unworn", cd2:"Very Good — minimal wear",
    cd3:"Good — normal wear", cd4:"Acceptable — visible wear",
    ac1:"Watch + Box + Papers (Full Set)", ac2:"Watch + Box", ac3:"Watch + Papers", ac4:"Watch Only",
    f_wm:"Desired Brand & Model", f_rf2:"Reference Number (if known)",
    f_cat:"Category", f_bmin:"Min. Budget (€)", f_bmax:"Max. Budget (€)",
    f_tf:"Timeframe", f_det:"Further Details & Wishes",
    f_priv2:"We will only contact you in relation to your sourcing request.",
    cat1:"Sports Watch", cat2:"Dress Watch / Classic", cat3:"Complication", cat4:"Vintage", cat5:"Fine Jewelry",
    tf1:"As soon as possible", tf2:"Within 1 month", tf3:"Within 3 months", tf4:"No rush",
    s_ok_h:"Thank You!", s_ok_p:"We'll be in touch within 24 hours.",
    src_ok_h:"Request Received!", src_ok_p:"We'll start immediately and contact you within 48 hours.",
    badge_new:"New", spec_cond:"Condition", spec_acc:"Accessories",
    cond_ex:"Excellent", cond_vg:"Very Good", cond_gd:"Good",
    t_cart_a:"added to cart", t_sub:"Subscribed — thank you!",
  }
};

let lang = localStorage.getItem('pd-lang') || (window.shopLocale === 'de' ? 'de' : 'de');
const t = k => (T[lang] && T[lang][k]) || T.de[k] || k;

function setLang(l) {
  lang = l;
  localStorage.setItem('pd-lang', l);
  ['de','en'].forEach(x => {
    const b = document.getElementById('b-'+x);
    if(b) b.classList.toggle('active', x===l);
  });
  document.documentElement.lang = l;
  applyLang();
  renderHero(); renderFeat();
}

function applyLang() {
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const k = el.dataset.i18n, v = t(k);
    if (!v) return;
    if (['INPUT','TEXTAREA'].includes(el.tagName)) { el.placeholder = v; }
    else if (el.tagName === 'OPTION') { el.textContent = v; }
    else { el.innerHTML = v.replace(/\n/g,'<br/>'); }
  });
  const annBar = document.getElementById('ann-bar');
  if(annBar) annBar.textContent = t('ann');
  const nlInput = document.getElementById('nl-i');
  if(nlInput) nlInput.placeholder = t('nl_ph');
  const bDe = document.getElementById('b-de');
  const bEn = document.getElementById('b-en');
  if(bDe) bDe.classList.toggle('active', lang==='de');
  if(bEn) bEn.classList.toggle('active', lang==='en');
}

// ── SVG WATCH ────────────────────────────────────────────────────────────────
function watchSVG(w, W2, H2) {
  const cx=W2/2, cy=H2/2, r=Math.min(W2,H2)*.26;
  const sw=W2*.32, sx=cx-sw/2, cH=H2*.52, cY=(H2-cH)/2;
  const ticks = [0,30,60,90,120,150,180,210,240,270,300,330].map(a=>{
    const rad=a*Math.PI/180, x1=cx+(r-.5)*Math.sin(rad), y1=cy-(r-.5)*Math.cos(rad);
    const len=a%90===0?7:4, x2=cx+(r-len)*Math.sin(rad), y2=cy-(r-len)*Math.cos(rad);
    return `<line x1="${x1.toFixed(1)}" y1="${y1.toFixed(1)}" x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}" stroke="${w.color}" stroke-width="${a%90===0?1.5:.8}" opacity=".7"/>`;
  }).join('');
  return `<svg viewBox="0 0 ${W2} ${H2}" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="${sx}" y="2" width="${sw}" height="${H2*.2}" rx="4" fill="${w.color}"/>
    <rect x="${sx}" y="${H2-H2*.2-2}" width="${sw}" height="${H2*.2}" rx="4" fill="${w.color}"/>
    <rect x="${cx-W2*.38}" y="${cY}" width="${W2*.76}" height="${cH}" rx="${W2*.1}" fill="${w.color}" opacity=".88"/>
    <circle cx="${cx}" cy="${cy}" r="${r+3}" fill="${w.color}" opacity=".55"/>
    <circle cx="${cx}" cy="${cy}" r="${r}" fill="${w.face}" stroke="${w.color}" stroke-width="1.2"/>
    ${ticks}
    <line x1="${cx}" y1="${cy}" x2="${cx.toFixed(1)}" y2="${(cy-r*.6).toFixed(1)}" stroke="${w.color}" stroke-width="2" stroke-linecap="round"/>
    <line x1="${cx}" y1="${cy}" x2="${(cx+r*.42).toFixed(1)}" y2="${(cy+r*.22).toFixed(1)}" stroke="${w.color}" stroke-width="1.5" stroke-linecap="round"/>
    <line x1="${cx}" y1="${cy}" x2="${(cx-r*.18).toFixed(1)}" y2="${(cy-r*.38).toFixed(1)}" stroke="${w.accent}" stroke-width="1.2" stroke-linecap="round"/>
    <circle cx="${cx}" cy="${cy}" r="2.2" fill="${w.color}"/>
    <rect x="${cx+W2*.36}" y="${cy-5}" width="8" height="10" rx="2" fill="${w.color}" opacity=".5"/>
  </svg>`;
}

function renderHero() {
  const el = document.getElementById('heroWatch');
  if(el) el.innerHTML = watchSVG({color:'#1a1a1a',face:'#111',accent:'#4a9a6a'}, 320, 400);
}
function renderFeat() {
  const el = document.getElementById('featWatch');
  if(el) el.innerHTML = watchSVG({color:'#2a2a2a',face:'#f5f0e8',accent:'#c9a96e'}, 260, 340);
}

// ── SHOPIFY CART ──────────────────────────────────────────────────────────────
async function addToShopifyCart(variantId) {
  try {
    await fetch('/cart/clear.js', {method:'POST'});
    const res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: variantId, quantity: 1})
    });
    if(!res.ok) throw new Error('Cart add failed');
    await refreshCart();
    openCart();
    toast(t('t_cart_a'));
  } catch(e) {
    console.error(e);
  }
}


async function buyNow(variantId) {
  try {
    await fetch('/cart/clear.js', {method:'POST'});
    const res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: variantId, quantity: 1})
    });
    if(!res.ok) throw new Error('failed');
    window.location.href = '/checkout';
  } catch(e) { console.error(e); }
}
async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderShopifyCart(cart);
  } catch(e) { console.error(e); }
}

function renderShopifyCart(cart) {
  const cN = document.getElementById('cN');
  const cTotal = document.getElementById('cTotal');
  const cartList = document.getElementById('cartList');
  if(cN) cN.textContent = cart.item_count;
  if(cTotal) cTotal.textContent = formatMoney(cart.total_price);
  if(!cartList) return;
  if(cart.item_count === 0) {
    cartList.innerHTML = `<div class="cart-empty">${t('cart_empty')}</div>`;
    return;
  }
  cartList.innerHTML = cart.items.map((item, i) => `
    <div class="cart-item">
      <div class="ci-img">
        ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
      </div>
      <div class="ci-info">
        <p class="ci-brand">${item.vendor}</p>
        <p class="ci-name">${item.title}</p>
        <p class="ci-price">${formatMoney(item.final_price)}</p>
      </div>
      <button class="ci-rm" onclick="removeFromCart('${item.key}')">×</button>
    </div>`).join('');
}

async function removeFromCart(key) {
  await fetch('/cart/change.js', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: key, quantity: 0})
  });
  await refreshCart();
}

function formatMoney(cents) {
  return '€ ' + (cents/100).toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2});
}

function openCart(){ document.getElementById('cartEl')?.classList.add('open'); document.getElementById('ov')?.classList.add('open'); document.body.style.overflow='hidden'; }
function closeCart(){ document.getElementById('cartEl')?.classList.remove('open'); document.getElementById('ov')?.classList.remove('open'); document.body.style.overflow=''; }

// ── TOAST ─────────────────────────────────────────────────────────────────────
function toast(msg){ const el=document.getElementById('toast'); if(!el) return; el.textContent=msg; el.classList.add('show'); setTimeout(()=>el.classList.remove('show'),2800); }

// ── INIT ──────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function(){
  applyLang();
  renderHero();
  renderFeat();
  refreshCart();
});